import React from 'react';
import { PhoneIcon, MapPinIcon, ClockIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full" aria-label="Hero" data-id="element-182">
      {/* Background with parallax */}
      <div className="parallax-bg absolute inset-0 z-0" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/ijKZt1ZRrqHwFYGY1nP21q/69934ac31eb3cf96d4cd5924.jpg)'
    }} aria-hidden="true" data-id="element-183" />
      {/* Dark overlay */}
      <div className="absolute inset-0 z-[1] bg-black/75" aria-hidden="true" data-id="element-184" />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center min-h-[90vh] md:min-h-screen px-4 sm:px-6 text-center" data-id="element-185">
        <div className="max-w-4xl mx-auto" data-id="element-186">
          <h1 className="font-oswald font-700 text-[28px] sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl uppercase leading-tight tracking-wide text-white mb-6" style={{
          textShadow: '2px 2px 8px rgba(0,0,0,0.8)'
        }} data-id="element-187">
            Arizona's Largest Used
            <br className="hidden sm:block" data-id="element-188" /> Construction Equipment Dealer
          </h1>
          <p className="text-brand-muted text-base sm:text-lg md:text-xl max-w-2xl mx-auto mb-10 leading-relaxed font-inter" data-id="element-189">
            Built on faith, integrity, and diligence — Payne Equipment Sales has
            served Arizona contractors with honest deals and quality equipment
            since day one.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12" data-id="element-190">
            <a href="#equipment" className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 bg-brand-orange text-white font-oswald font-semibold text-base sm:text-lg uppercase tracking-wider rounded-md hover:bg-brand-orange/90 transition-colors duration-200 min-h-[48px]" data-id="element-191">
              View Equipment for Sale
            </a>
            <a href="#contact" className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 bg-white text-[#1A1A1A] font-oswald font-semibold text-base sm:text-lg uppercase tracking-wider rounded-md hover:bg-[#1A1A1A] hover:text-white border-2 border-white transition-colors duration-200 min-h-[48px]" data-id="element-192">
              Get a Quote
            </a>
          </div>
        </div>
      </div>

      {/* Info Strip */}
      <div className="relative z-10 w-full bg-brand-card/90 backdrop-blur-sm border-t border-brand-border" data-id="element-193">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-194">
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-12 text-sm sm:text-base" data-id="element-195">
            <a href="tel:+16232998071" className="flex items-center gap-2 text-white hover:text-brand-orange transition-colors min-h-[48px]" data-id="element-196">
              <PhoneIcon className="w-5 h-5 text-brand-orange flex-shrink-0" aria-hidden="true" data-id="element-197" />
              <span data-id="element-198">(623) 299-8071</span>
            </a>
            <div className="flex items-center gap-2 text-white" data-id="element-199">
              <MapPinIcon className="w-5 h-5 text-brand-orange flex-shrink-0" aria-hidden="true" data-id="element-200" />
              <span data-id="element-201">Peoria, AZ 85382</span>
            </div>
            <div className="flex items-center gap-2 text-white" data-id="element-202">
              <ClockIcon className="w-5 h-5 text-brand-orange flex-shrink-0" aria-hidden="true" data-id="element-203" />
              <span data-id="element-204">Mon–Fri 7AM–5PM &bull; Sat by Appt</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}